import React, { useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Typography,
} from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);
const { Title, Text } = Typography;

const DodatneInformacije = ({
  podacioKlijentu,
  onFinish,
  goBack,
  offerToEdit,
}) => {
  const [form] = Form.useForm();
  const [netoPlata, setNetoPlata] = useState(
    offerToEdit ? offerToEdit.clientNetSalary : 0
  );
  const [topliObrok, setTopliObrok] = useState(
    offerToEdit ? offerToEdit.clientMealAllowance : 0
  );
  const [naknadaPrevoz, setNaknadaPrevoz] = useState(
    offerToEdit ? offerToEdit.clientTransportAllowance : 0
  );
  const [redovniMjesecniPrihodi, setRedovniMjesecniPrihodi] = useState(0);
  const [mjesecnaRata, setMjesecnaRata] = useState(
    offerToEdit ? offerToEdit.installment : 0
  );
  const [dodatniiMjesecniPrihodi, setDodatniMjesecniPrihodi] = useState(
    offerToEdit ? offerToEdit.clientAdditionalMonthlyIncome : 0
  );
  const [ukupniMjesecniPrihodi, setUkupniMjesecniPrihodi] = useState(0);

  useEffect(() => {
    const sum = netoPlata + topliObrok + naknadaPrevoz;
    setRedovniMjesecniPrihodi(sum > 0 ? sum : null);
    form.setFieldsValue({
      prihodi: sum > 0 ? sum : null,
    });
  }, [netoPlata, topliObrok, naknadaPrevoz]);

  useEffect(() => {
    const sum = redovniMjesecniPrihodi + dodatniiMjesecniPrihodi - mjesecnaRata;
    setUkupniMjesecniPrihodi(sum > 0 ? sum : null);
    form.setFieldsValue({
      ["prihodi-ukupni"]: sum > 0 ? sum : null,
    });
  }, [redovniMjesecniPrihodi, mjesecnaRata, dodatniiMjesecniPrihodi]);

  const kaskoCalculated = () => {
    return 1000;
  };

  const rataNovogZaduzenjaCalculated = () => {
    return 100;
  };

  const dateFormat = "YYYY-MM-DD";

  return (
    <div>
      <div className="py-6 px-8">
        <Title className="text-dark-blue text-xl font-bold m-0 ">
          DODATNE INFORMACIJE O KLIJENTU
        </Title>
      </div>
      <div className="h-4 bg-padding-white"></div>
      <div className="p-8">
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <div className="flex justify-between gap-14">
            <div className="w-4/5">
              <Form.Item
                initialValue={podacioKlijentu.companyName}
                label="Ime i prezime klijenta"
                name="klijentFL"
              >
                <Input />
              </Form.Item>
            </div>
            <div className="w-4/5">
              <Form.Item name="datum" label="Datum rođenja">
                <DatePicker
                  defaultValue={
                    offerToEdit
                      ? offerToEdit.clientDateOfBirth
                        ? dayjs(offerToEdit.clientDateOfBirth, dateFormat)
                        : null
                      : null
                  }
                  format={dateFormat}
                  placeholder="Odaberi datum"
                  className="w-full"
                />
              </Form.Item>
            </div>
            <div className=" w-4/5 ">
              <Form.Item
                initialValue={offerToEdit && offerToEdit.clientHouseholdMembers}
                label="Broj članova domaćinstva"
                name="domacinstvo"
              >
                <InputNumber className="w-full" min={0} type="number" />
              </Form.Item>
            </div>
          </div>
          <Divider className="mt-0 mb-4 " />
          <div className="flex justify-between gap-14">
            <div className="w-4/5">
              <Form.Item
                initialValue={offerToEdit && offerToEdit.clientNetSalary}
                colon={false}
                label="Neto plata"
                name="neto-plata"
              >
                <InputNumber
                  onChange={(e) => setNetoPlata(e)}
                  type="number"
                  className="w-full"
                  min={0}
                  placeholder="Unesite vrijednost"
                />
              </Form.Item>
              <Form.Item
                colon={false}
                label="Redovni mjesečni prihodi"
                name="prihodi"
              >
                <InputNumber
                  disabled
                  type="number"
                  className="w-full"
                  min={0}
                />
              </Form.Item>
            </div>
            <div className="w-4/5">
              <Form.Item
                initialValue={offerToEdit && offerToEdit.clientMealAllowance}
                colon={false}
                label="Topli obrok"
                name="obrok"
              >
                <InputNumber
                  onChange={(e) => setTopliObrok(e)}
                  type="number"
                  className="w-full"
                  min={0}
                  placeholder="Unesite vrijednost"
                />
              </Form.Item>

              <Form.Item
                initialValue={offerToEdit && offerToEdit.installment}
                colon={false}
                label="Ukupan iznos mjesečnih rata koji se plaća"
                name="mjesecna-rata"
              >
                <InputNumber
                  onChange={(e) => setMjesecnaRata(e)}
                  type="number"
                  className="w-full"
                  min={0}
                  placeholder="Unesite vrijednost"
                />
              </Form.Item>
            </div>
            <div className="w-4/5">
              <Form.Item
                initialValue={
                  offerToEdit && offerToEdit.clientTransportAllowance
                }
                colon={false}
                label="Naknada za prevoz"
                name="naknada"
              >
                <InputNumber
                  onChange={(e) => setNaknadaPrevoz(e)}
                  type="number"
                  className="w-full"
                  min={0}
                  placeholder="Unesite vrijednost"
                />
              </Form.Item>

              <Form.Item
                initialValue={
                  offerToEdit && offerToEdit.clientAdditionalMonthlyIncome
                }
                colon={false}
                label="Dodatni mjesečni prihodi"
                name="prihodi-dodatni"
              >
                <InputNumber
                  onChange={(e) => setDodatniMjesecniPrihodi(e)}
                  type="number"
                  className="w-full"
                  min={0}
                  placeholder="Unesite vrijednost"
                />
              </Form.Item>
            </div>
          </div>
          <Divider className="mt-0 mb-4" />
          <div className="flex justify-between gap-14">
            <div className="w-4/5 ">
              <Form.Item
                colon={false}
                label="Ukupni mjesečni prihodi"
                name="prihodi-ukupni"
              >
                <InputNumber
                  disabled
                  type="number"
                  className="w-full"
                  min={0}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  htmlType="button"
                  onClick={goBack}
                  className=" mt-2 text-sm text-white bg-light-blue font-medium w-[132px]  border-light-blue shadow-sm"
                >
                  NAZAD
                </Button>
              </Form.Item>
            </div>
            <div className="w-4/5">
              <Form.Item
                colon={false}
                label="Visina rate novog leasing zaduženja"
                name="novi-leasing"
              >
                <InputNumber
                  defaultValue={rataNovogZaduzenjaCalculated()}
                  disabled
                  type="number"
                  className="w-full"
                  min={0}
                />
              </Form.Item>
            </div>
            <div className="w-4/5">
              <Form.Item
                colon={false}
                label="(Kasko + AO polica)/12"
                name="polica"
              >
                <InputNumber
                  defaultValue={kaskoCalculated()}
                  disabled
                  type="number"
                  className="w-full"
                  min={0}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="text-sm text-white bg-light-blue font-medium w-[132px]  border-light-blue shadow-sm mt-2"
                >
                  SPREMI
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default DodatneInformacije;
